<template>
    <div id="app" v-if="ready">

        <div v-if="!isBrowserSupported" class="unsupported-block">
            <b-field v-if="!isBrowserSupported">
                <b-message type="is-danger">
                    {{ texts.browserNotSupported }}
                </b-message>
            </b-field>
        </div>

        <router-view v-else />
    </div>
</template>

<script>
import axios from 'axios';
import HealthCareService from './services/HealthCareService';

export default {
    name: 'App',
    data () {
        return {
            isBrowserSupported: true,
            config: {},
            texts: {},
            ready: false
        }
    },
    mounted() {
        DetectRTC.load(() => {
            this.isBrowserSupported = this.browserSupported();
        })
        axios.get(`/static/config.json`)
            .then(res => {
                this.config = res.data;
                axios.get(`/static/texts.json`)
                    .then(res => {
                        this.texts = res.data;
                        this.checkLoginSso();
                    })
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch(err => {
                console.log(err);
            });
    },
    methods: {
        browserSupported() {
            let isSupported = true;
            if (window.navigator.userAgent.indexOf('Miui') >= 0) isSupported = false;
            if (!DetectRTC.isWebRTCSupported) isSupported = false;
            return isSupported;
        },
        checkLoginSso() {
            const qString = window.location.search;
            const urlParams = new URLSearchParams(qString);
            const sso = urlParams.get('sso');
            if (!HealthCareService.isLogged() && sso) {
                this.loginSso(sso);
            } else {
                this.ready = true;
            }
        },
        loginSso(sso) {
            this.isLoading = true;
                HealthCareService.login({ sso })
                    .then(response => {
                        if (response && response.data && response.data.token) {
                            const token = response.data.token;
                            localStorage.setItem('token', token);
                            localStorage.setItem('user', HealthCareService.getUser());
                        }
                        this.ready = true;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.ready = true;
                        const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                        this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                        this.isLoading = false;
                    });
        },
    },
}
</script>

<style lang="scss">

html {
    overflow: auto;
}

.unsupported-block {
    position: absolute;
    margin: 0 auto;
    width: 600px;
    max-width: 95%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/* VideoRTC Font */
$videortc-icon-fast-forward: "\e920";
$videortc-icon-pause: "\e921";
$videortc-icon-play: "\e922";
$videortc-icon-play-next: "\e923";
$videortc-icon-previous-track: "\e924";
$videortc-icon-rewind: "\e925";
$videortc-icon-stop: "\e926";
$videortc-icon-Copy1: "\e91e";
$videortc-icon-Copy2: "\e91f";
$videortc-icon-Call: "\e900";
$videortc-icon-callback: "\e901";
$videortc-icon-Cobrowsing: "\e902";
$videortc-icon-Cobrowsing-No: "\e903";
$videortc-icon-Filesharing: "\e904";
$videortc-icon-Filesharing-No: "\e906";
$videortc-icon-Hangup: "\e907";
$videortc-icon-Keymap: "\e908";
$videortc-icon-Keymap-No: "\e909";
$videortc-icon-Livechat: "\e90a";
$videortc-icon-Livechat-No: "\e90c";
$videortc-icon-Lock-Close: "\e90d";
$videortc-icon-Lock-Open: "\e90e";
$videortc-icon-Logo: "\e90f";
$videortc-icon-Micro: "\e910";
$videortc-icon-Micro-No: "\e911";
$videortc-icon-Record: "\e912";
$videortc-icon-Screensharing: "\e913";
$videortc-icon-Screensharing-No: "\e915";
$videortc-icon-Settings: "\e916";
$videortc-icon-Sound: "\e917";
$videortc-icon-Sound-No: "\e918";
$videortc-icon-Warning: "\e919";
$videortc-icon-Watch: "\e91a";
$videortc-icon-Watch-No: "\e91b";
$videortc-icon-Webcam: "\e91c";
$videortc-icon-Webcam-No: "\e91d";
$videortc-icon-flip-speaker: "\e927";
$videortc-icon-flip-micro: "\e928";
$videortc-icon-flip-cam: "\e929";
$videortc-icon-cross: "\e92a";
$videortc-icon-cam: "\e92b";
$videortc-icon-cam-no: "\e92c";
$videortc-icon-qr-code-scan-close: "\e92d";
$videortc-icon-qr-code-scan: "\e92e";
$videortc-icon-scan: "\e92f";
$videortc-icon-scan-close: "\e930";
$videortc-icon-scan-qr-code: "\e931";
$videortc-icon-survey: "\e932";
$videortc-icon-tester: "\e933";
$videortc-icon-faceid: "\e934";
$videortc-icon-Screen: "\e935";
$videortc-icon-Paste: "\e936";
$videortc-icon-Mail: "\e937";
$videortc-icon-Call-Reverse: "\e938";
$videortc-icon-Trash: "\e939";
$videortc-icon-Arrow-Rotate-Right: "\e93a";
$videortc-icon-Arrow-Rotate-Left: "\e93c";
$videortc-icon-Send: "\e93d";
$videortc-icon-Right-From-Bracket: "\e93e";
$videortc-icon-flip: "\e940";
$videortc-icon-ad: "\e941";
$videortc-icon-scan-person: "\e942";
$videortc-icon-arrow-left: "\e943";
$videortc-icon-window: "\e944";
$videortc-icon-arrow-right: "\e945";
@font-face {
    font-family: "videortc";
    src: url("/static/fonts/videortc/videortc.eot?adqse8");
    src: url("/static/fonts/videortc/videortc.eot?adqse8#iefix") format("embedded-opentype"),
        url("/static/fonts/videortc/videortc.ttf?adqse8") format("truetype"),
        url("/static/fonts/videortc/videortc.woff?adqse8") format("woff"),
        url("/static/fonts/videortc/videortc.svg?adqse8#videortc") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

@font-face {
    font-family: "videortc-light";
    src: url("/static/fonts/videortc/videortc-light.eot?adqse8");
    src: url("/static/fonts/videortc/videortc-light.eot?adqse8#iefix") format("embedded-opentype"),
        url("/static/fonts/videortc/videortc-light.ttf?adqse8") format("truetype"),
        url("/static/fonts/videortc/videortc-light.woff?adqse8") format("woff"),
        url("/static/fonts/videortc/videortc-light.svg?adqse8#videortc-light") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}
[class^="videortc-icon"], [class*=" videortc-icon"] {
    font-family: 'videortc' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.videortc-icon-fast-forward {
    &:before {
        content: $videortc-icon-fast-forward;
    }
}
.videortc-icon-pause {
    &:before {
        content: $videortc-icon-pause;
    }
}
.videortc-icon-play {
    &:before {
        content: $videortc-icon-play;
    }
}
.videortc-icon-play-next {
    &:before {
        content: $videortc-icon-play-next;
    }
}
.videortc-icon-previous-track {
    &:before {
        content: $videortc-icon-previous-track;
    }
}
.videortc-icon-rewind {
    &:before {
        content: $videortc-icon-rewind;
    }
}
.videortc-icon-stop {
    &:before {
        content: $videortc-icon-stop;
    }
}
.videortc-icon-Copy1 {
    &:before {
        content: $videortc-icon-Copy1;
    }
}
.videortc-icon-Copy2 {
    &:before {
        content: $videortc-icon-Copy2;
    }
}
.videortc-icon-Call {
    &:before {
        content: $videortc-icon-Call;
    }
}
.videortc-icon-callback {
    &:before {
        content: $videortc-icon-callback;
    }
}
.videortc-icon-Cobrowsing {
    &:before {
        content: $videortc-icon-Cobrowsing;
    }
}
.videortc-icon-Cobrowsing-No {
    &:before {
        content: $videortc-icon-Cobrowsing-No;
    }
}
.videortc-icon-Filesharing {
    &:before {
        content: $videortc-icon-Filesharing;
    }
}
.videortc-icon-Filesharing-No {
    &:before {
        content: $videortc-icon-Filesharing-No;
    }
}
.videortc-icon-Hangup {
    &:before {
        content: $videortc-icon-Hangup;
    }
}
.videortc-icon-Keymap {
    &:before {
        content: $videortc-icon-Keymap;
    }
}
.videortc-icon-Keymap-No {
    &:before {
        content: $videortc-icon-Keymap-No;
    }
}
.videortc-icon-Livechat {
    &:before {
        content: $videortc-icon-Livechat;
    }
}
.videortc-icon-Livechat-No {
    &:before {
        content: $videortc-icon-Livechat-No;
    }
}
.videortc-icon-Lock-Close {
    &:before {
        content: $videortc-icon-Lock-Close;
    }
}
.videortc-icon-Lock-Open {
    &:before {
        content: $videortc-icon-Lock-Open;
    }
}
.videortc-icon-Logo {
    &:before {
        content: $videortc-icon-Logo;
    }
}
.videortc-icon-Micro {
    &:before {
        content: $videortc-icon-Micro;
    }
}
.videortc-icon-Micro-No {
    &:before {
        content: $videortc-icon-Micro-No;
    }
}
.videortc-icon-Record {
    &:before {
        content: $videortc-icon-Record;
    }
}
.videortc-icon-Screensharing {
    &:before {
        content: $videortc-icon-Screensharing;
    }
}
.videortc-icon-Screensharing-No {
    &:before {
        content: $videortc-icon-Screensharing-No;
    }
}
.videortc-icon-Settings {
    &:before {
        content: $videortc-icon-Settings;
    }
}
.videortc-icon-Sound {
    &:before {
        content: $videortc-icon-Sound;
    }
}
.videortc-icon-Sound-No {
    &:before {
        content: $videortc-icon-Sound-No;
    }
}
.videortc-icon-Warning {
    &:before {
        content: $videortc-icon-Warning;
    }
}
.videortc-icon-Watch {
    &:before {
        content: $videortc-icon-Watch;
    }
}
.videortc-icon-Watch-No {
    &:before {
        content: $videortc-icon-Watch-No;
    }
}
.videortc-icon-Webcam {
    &:before {
        content: $videortc-icon-Webcam;
    }
}
.videortc-icon-Webcam-No {
    &:before {
        content: $videortc-icon-Webcam-No;
    }
}
.videortc-icon-flip-speaker {
    &:before {
        content: $videortc-icon-flip-speaker;
    }
}
.videortc-icon-flip-micro {
    &:before {
        content: $videortc-icon-flip-micro;
    }
}
.videortc-icon-flip-cam {
    &:before {
        content: $videortc-icon-flip-cam;
    }
}
.videortc-icon-cross {
    &:before {
        content: $videortc-icon-cross;
    }
}
.videortc-icon-cam {
    &:before {
        content: $videortc-icon-cam;
    }
}
.videortc-icon-cam-no {
    &:before {
        content: $videortc-icon-cam-no;
    }
}
.videortc-icon-qr-code-scan-close {
    &:before {
        content: $videortc-icon-qr-code-scan-close;
    }
}
.videortc-icon-qr-code-scan {
    &:before {
        content: $videortc-icon-qr-code-scan;
    }
}
.videortc-icon-scan {
    &:before {
        content: $videortc-icon-scan;
    }
}
.videortc-icon-scan-close {
    &:before {
        content: $videortc-icon-scan-close;
    }
}
.videortc-icon-scan-qr-code {
    &:before {
        content: $videortc-icon-scan-qr-code;
    }
}
.videortc-icon-survey {
    &:before {
        content: $videortc-icon-survey;
    }
}
.videortc-icon-tester {
    &:before {
        content: $videortc-icon-tester;
    }
}
.videortc-icon-faceid {
    &:before {
        content: $videortc-icon-faceid;
    }
}
.videortc-icon-Screen {
    &:before {
        content: $videortc-icon-Screen;
    }
}
.videortc-icon-Paste {
    &:before {
        content: $videortc-icon-Paste;
    }
}
.videortc-icon-Mail {
    &:before {
        content: $videortc-icon-Mail;
    }
}
.videortc-icon-Call-Reverse {
    &:before {
        content: $videortc-icon-Call-Reverse;
    }
}
.videortc-icon-Trash {
    &:before {
        content: $videortc-icon-Trash;
    }
}
.videortc-icon-Arrow-Rotate-Right {
    &:before {
        content: $videortc-icon-Arrow-Rotate-Right;
    }
}
.videortc-icon-Arrow-Rotate-Left {
    &:before {
        content: $videortc-icon-Arrow-Rotate-Left;
    }
}
.videortc-icon-Send {
    &:before {
        content: $videortc-icon-Send;
    }
}
.videortc-icon-Right-From-Bracket {
    &:before {
        content: $videortc-icon-Right-From-Bracket;
    }
}
.videortc-icon-flip {
    &:before {
        content: $videortc-icon-flip;
    }
}
.videortc-icon-ad {
    &:before {
        content: $videortc-icon-ad;
    }
}
.videortc-icon-scan-person {
    &:before {
        content: $videortc-icon-scan-person;
    }
}
.videortc-icon-arrow-left {
    &:before {
        content: $videortc-icon-arrow-left;
    }
}
.videortc-icon-window {
    &:before {
        content: $videortc-icon-window;
    }
}
.videortc-icon-arrow-right {
    &:before {
        content: $videortc-icon-arrow-right;
    }
}

/* Montserrat Family */
@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-Thin.ttf');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-ExtraLight.ttf');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-Light.ttf');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-Regular.ttf');
    font-weight: 400;
    font-display: swap;
}

@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-Medium.ttf');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-SemiBold.ttf');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-Bold.ttf');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-ExtraBold.ttf');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: Montserrat;
    src: url('/static/fonts/Montserrat/Montserrat-Black.ttf');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}

body {
    font-family: Montserrat, Arial, Noto Sans, sans-serif;
    font-weight: 400;
}

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 20px;
}

/*.modal-card {
    max-width: 90% !important;
}*/
.modal-card.animation-content {
    max-width: 95% !important;
}

.calling-icon {
    width: 4rem !important;
    height: 4rem !important;
}

#videocall {
    background-repeat: no-repeat;
    background-size: cover;
    background: white;
    width: 100%;
    height: 100%;
    top: 0;
    position: absolute;
    overflow: hidden;
    margin: 0;
    #localvideo {
        position: fixed;
        bottom: 20px;
        left: 20px;
        z-index: 2;
        video {
            width: 100px;
            height: auto;
        }
    }
    #container-remote {
        height: 100%;
        width: auto;
        position: relative;
        span[id^="remote-"] {
            display: none !important;
        }
        video {
            height: 100vh;
            width: auto;
            max-width: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
    }
}

.no-camera-available {
    color: white;
    position: absolute !important;
}

.switch .control-label {
    padding-left: 0;
}

.has-text-primary {
    color: #2c3e50 !important;
}
.icon {
    .cog-icon {
            width: 1.5em !important;
            height: 1.5em !important;
    }
}
.control-label-confirm {
    padding-left: 10px !important;
    font-size: .9em !important;
}
.notification {
    padding: 15px;
    margin: 0px !important;
    margin-top: 10px !important;
    margin-right: 10px !important;
    background-color: #94C2ED !important;
    opacity: .75 !important;
}
.chat {
    input {
        border-bottom-left-radius: 0px;
    }
    .input:focus, .taginput .taginput-container.is-focusable:focus, .textarea:focus, .select select:focus, .is-focused.input, .taginput .is-focused.taginput-container.is-focusable, .is-focused.textarea, .select select.is-focused, .input:active, .taginput .taginput-container.is-focusable:active, .textarea:active, .select select:active, .is-active.input, .taginput .is-active.taginput-container.is-focusable, .is-active.textarea, .select select.is-active {
        border-color: #fff;
        -webkit-box-shadow: 0;
        box-shadow: 0;
    }
}

.background-enabled {
    background: url('/static/background-large.png') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: contain;
    @media (max-width: 767px) {
        background: url('/static/background-square.png') no-repeat center center fixed;
        background-size: 280px;
    }
}
.background-enabled-gray {
    background-color: #929292;
}

.upload, .upload-draggable {
    width: 100%;
    .section {
        padding: 1rem .5rem
    }
}

.slow-link {
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    padding-top: 45vh;
}

.join-icon {
    height: 48px !important;
    width: 48px !important;
}

.ban-icon {
    width: 3rem !important;
    height: 3rem !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue